import { ProgramFixedContentRowUpsert } from '../types/domain';

export type ProgramWorkspaceScopeType = 'fixed' | 'project' | 'track';

/** patch: 변경 행만(칸 편집) — 저장 시 DB 전량과 병합. replace: 표 전체 스냅샷(삽입·삭제·재정렬). */
export type ProgramWorkspacePersistKind = 'patch' | 'replace';

export type ProgramWorkspaceRowsChangeMeta = {
  persistKind?: ProgramWorkspacePersistKind;
};

export function resolveProgramWorkspacePersistKind(
  meta: ProgramWorkspaceRowsChangeMeta | undefined,
  rowsFromTableLength: number,
  baselineLength: number
): ProgramWorkspacePersistKind {
  if (meta?.persistKind) return meta.persistKind;
  /** 행 추가·삭제·통합 등 개수 변화 시 전량 스냅샷으로 저장해 DB와 UI 순서·삭제가 일치한다. */
  return rowsFromTableLength !== baselineLength ? 'replace' : 'patch';
}

export type ProgramWorkspaceClipboardCell = {
  rowOffset: number;
  colOffset: number;
  fieldId: string;
  value: string;
  bgColor?: string;
  recordMemberGroupId?: string | null;
  slideCopyFrom?: { kind: 'scoped_row' | 'fixed_row' | 'program_cell' | 'presentation_ref'; id: string };
};

export type ProgramWorkspaceClipboard = {
  cells: ProgramWorkspaceClipboardCell[];
  isCut: boolean;
  sourceCellIds: string[];
  sourceScopeId: string;
};

export type ProgramWorkspaceScopeEntry = {
  scopeId: string;
  scopeType: ProgramWorkspaceScopeType;
  scopeKey: string;
  workspaceId: string;
  gradeId: string;
  academicYear: number;
  termNumber: 1 | 2;
  rows: ProgramFixedContentRowUpsert[];
  isDirty: boolean;
  updatedAt: number;
  persistKind?: ProgramWorkspacePersistKind;
  /** patch 저장 시 변경된 행 식별자(id / source_annual_cell_key / order_index) */
  dirtyRowKeys?: string[];
  /** replace 저장 시 삭제된 DB row id */
  deletedRowIds?: string[];
  /** 서버 baseline `count:max(updated_at)` — head 비교·충돌 감지용 */
  baselineRevision?: string;
  trackSyncFanoutScopeKeys?: readonly string[];
  trackSyncScheduleAnnualKeysByScope?: Readonly<Record<string, readonly string[]>>;
};

export type ProgramWorkspaceState = {
  scopes: Record<string, ProgramWorkspaceScopeEntry>;
  clipboard: ProgramWorkspaceClipboard | null;
};
